module.exports = __webpack_public_path__ + "static/media/splash.8eb59944.png";